"use client";

import { __ } from "@/i18n";
import { IconSelector } from "./icon-selector";
import { ColorPicker } from "./color-picker";
import { LanguageSelector } from "@/components/language-selector";
import { SizeSelector } from "./size-selector";

export function WidgetAppearance() {
  return (
    <div className="cy:flex cy:flex-col cy:gap-4">
      <div className="cy:flex cy:flex-col cy:gap-6 cy:pb-6 cy:border-b cy:border-gray-200">
        <h2 className="cy:text-lg! cy:font-bold cy:m-0!">{__( 'Widget language', 'accessibility-widget' )}</h2>
        <LanguageSelector />
        <div className="cy:flex cy:-mt-4">
          <p className="cy:text-[10px] cy:text-[#535276]">
            {__( "Note: The widget will appear in the visitor's browser language. If it's not in our supported list, it will show in the language you've selected.", 'accessibility-widget' )}
          </p>
        </div>
      </div>
      <div className="cy:flex cy:flex-col cy:gap-6 cy:pb-6 cy:border-b cy:border-gray-200">
        <h2 className="cy:text-lg! cy:font-bold cy:m-0!">{__( 'Widget colour', 'accessibility-widget' )}</h2>
        <ColorPicker />
      </div>
      <div className="cy:flex cy:flex-col cy:gap-6 cy:pb-6 cy:border-b cy:border-gray-200">
        <h2 className="cy:text-lg! cy:font-bold cy:m-0!">{__( 'Widget icon', 'accessibility-widget' )}</h2>
        <IconSelector />
        <SizeSelector />
      </div>
    </div>
  );
}
